import React from "react";
import { Route, Routes } from "react-router-dom";

import ListPrice from "@/components/screens/ListPrice";
import ListPriceFormPage from "@/components/screens/ListPriceFormPage";
import { LIST_PRICE_FORM_PAGE_MESSAGES } from "@/messages/listPrice/list-price-form-page.messages";
import { LIST_PRICE_MESSAGES } from "@/messages/listPrice/list-price.messages";

const ListPricePage: React.FC = () => {
  return (
    <Routes>
      <Route path="/:lang" element={<ListPrice messages={LIST_PRICE_MESSAGES} />} />
      <Route
        path="/update/:listPriceId/:lang"
        element={<ListPriceFormPage messages={LIST_PRICE_FORM_PAGE_MESSAGES} isEditing />}
      />
      <Route path="/" element={<ListPrice messages={LIST_PRICE_MESSAGES} />} />
    </Routes>
  );
};

export default ListPricePage;
